export default {
  districts: [],
  districtTo: [],
  districtFrom: [],
  district: {},
  districtsByCityCode: {}
}



// WEBPACK FOOTER //
// ./src/components/district/store/state.js